// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Login from "./components/Login";
import DashboardLayout from "./layouts/DashboardLayout";
import DashboardHome from "./pages/DashboardHome";
import Leads from "./pages/Leads";
import LeadDetail from "./pages/LeadDetail";
import ControlPanel from "./pages/ControlPanel";
import MyFollowups from "./pages/MyFollowups";
import MyCustomers from "./pages/MyCustomers";
import TasksNotes from "./pages/TasksNotes";
import CommissionSettings from "./pages/CommissionSettings";
import SalarySummary from "./pages/SalarySummary";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { ReminderProvider } from "./context/ReminderContext";
import { ChatProvider } from "./context/ChatContext";
import AddCar from "./pages/Stock/AddCar";
import StockList from "./pages/Stock/StockList";
import ProfilePage from "./pages/ProfilePage";
import MyTeam from "./pages/MyTeam";
import TeamPortfolio from "./pages/TeamPortfolio";

// Phase 2 — new pages
import AttendanceDashboard from "./pages/AttendanceDashboard";
import EmailClient from "./pages/EmailClient.jsx";
import Payroll from "./pages/Payroll";
import SalesTracking from "./pages/SalesTracking";
import Reports from "./pages/Reports";
import OnboardingPage from "./pages/OnboardingPage";
import Auction from "./pages/Auction";


import "./styles/theme.css";

function App() {
  return (
    <AuthProvider>
      <ReminderProvider>
        <ChatProvider>
          <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#141519',
            color: '#F5F5F7',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.08)',
            borderRadius: '12px',
            fontSize: '13px',
            fontWeight: 500,
          },
          success: { iconTheme: { primary: '#30D158', secondary: '#fff' } },
          error:   { iconTheme: { primary: '#FF453A', secondary: '#fff' } },
        }}
      />

      <Routes>
        {/* Public */}
        <Route path="/" element={<Login />} />

        {/* First-time Onboarding & Policies (protected, but does not self-redirect) */}
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute checkOnboarding={false}>
              <OnboardingPage />
            </ProtectedRoute>
          }
        />

        {/* Dashboard (protected) */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardHome />} />
          <Route path="leads"          element={<Leads />} />
          <Route path="leads/:id"      element={<LeadDetail />} />
          <Route path="my-followups"   element={<MyFollowups />} />
          <Route path="my-customers"   element={<MyCustomers />} />
          <Route path="tasks"          element={<TasksNotes />} />
          <Route path="add-car"        element={<AddCar />} />
          <Route path="stock-list"     element={<StockList />} />
          <Route path="profile"        element={<ProfilePage />} />
          <Route path="my-team"        element={<MyTeam />} />
          <Route path="team-portfolio" element={<TeamPortfolio />} />

          {/* Phase 2 — Attendance (unified Dashboard & History) */}
          <Route path="attendance"         element={<AttendanceDashboard />} />
          <Route path="email"              element={<EmailClient />} />
          <Route path="attendance-history" element={<AttendanceDashboard />} />

          {/* Phase 2 — Payroll (unified, replaces old pages) */}
          <Route path="payroll" element={<Payroll />} />
          {/* Legacy redirects — keep working so existing bookmarks don't break */}
          <Route path="commissions"    element={<Payroll />} />
          <Route path="salary-summary" element={<Payroll />} />

          {/* Phase 2 — Sales */}
          <Route path="sales" element={<SalesTracking />} />

          {/* Phase 2 — Reports */}
          <Route path="reports" element={<Reports />} />
          <Route path="auction" element={<Auction />} />

          {/* Admin only */}
          <Route path="control-panel"    element={<ControlPanel />} />
          {/* Keep old commission routes for backwards compat */}
          <Route path="commission-settings" element={<CommissionSettings />} />
          <Route path="salary"              element={<SalarySummary />} />
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Login />} />
      </Routes>
        </ChatProvider>
      </ReminderProvider>
    </AuthProvider>
  );
}

export default App;